<script lang="ts">
  import VerifiableLogo from '$shared/images/verifiable-logo.svg';
  import Monitoring from './_partials/Monitoring.svelte';
  enum MetaDetailsKey {
    Source = 'source',
    LastUpdated = 'lastUpdated',
    VerifiedOn = 'verifedOn',
    MonitorConfig = 'monitorConfig',
    Verified = 'verified'
  }
  interface Props {
    meta?: any;
    showIcon?: boolean;
    monitorConfig?: any;
  }

  let { meta = {}, showIcon = false, monitorConfig = null }: Props = $props();

  const cleanMetaList = (list = {}) => {
    const tempList = { ...list };
    Object.keys(tempList).forEach((key) => {
      if (key.indexOf(MetaDetailsKey.LastUpdated) !== -1) {
        delete tempList[key];
      }
    });
    if (monitorConfig) {
      return Object.assign(tempList, { monitorConfig });
    }
    return { ...tempList };
  };
</script>

{#if meta && Object.keys(meta).length !== 0}
  <div class="meta">
    {#if showIcon && meta.source}
      <div class="logo"><img src={VerifiableLogo} alt="verifable" /></div>
    {/if}
    {#each Object.entries(cleanMetaList(meta)) as [key, value]}
      {#if value}
        <div data-cy={`metaInfo-${key}`} class="meta-i">
          {#if key === MetaDetailsKey.MonitorConfig}
            <Monitoring config={value} />
          {:else}
            {key.withSpaceAfterCapitalLetters().capitaliseFirstString()}: {value}
            {#if key === MetaDetailsKey.Source && meta.lastUpdated}
              <div data-cy="meta-info-lastUpdated" class="last-updated">
                (Source last updated: {meta.lastUpdated})
              </div>
            {/if}
          {/if}
        </div>
      {/if}
    {/each}
  </div>
{/if}

<style>
  .meta {
    display: flex;
    align-items: center;
    font-weight: normal;
    font-size: 11px;
    line-height: 18px;
    color: var(--grey-medium);
  }
  .meta-i {
    display: flex;
    align-items: center;
  }
  .meta-i:not(:last-child) {
    margin-right: 4px;
  }
  .meta-i:not(:last-child)::after {
    content: '';
    width: 1px;
    height: 10px;
    background-color: var(--grey-medium);
    display: block;
    margin-left: 4px;
  }
  .logo {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  .logo img {
    width: 100%;
  }
  .last-updated {
    margin-left: 5px;
  }
</style>
